import React from 'react'

import Hero from '/react4xp/components/Hero'

import { HeroPartProps } from './hero.d';

function HeroPart(props: HeroPartProps) {
    return (
        <Hero
            layout={props.layout}
            breadcrumbs={props.breadcrumbs}
            image={props.image}
            title={props.title}
            description={props.description}
            button={props.button}
        />
    )
}

export default (props) => <HeroPart {...props} /> 